/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'jquery',
    'mustache',
    'pip-model',
    'pip-analytics__hddata',
    'pip-events',
    'pip-overlays__fbtIrgAtcConfirmation',
    'cookie-utils',
    'pip-cart'
],
function(
    $,
    Mustache,
    pip,
    pipAnalyticsHDdata,
    pipEvents,
    fbtAtcOverlay,
    cookieUtils,
    pipCart
){

	var model = {};
	var	view = {
	  templates : {
      // TODO: Collapse mediaEntryLocation.
      main : $('#fbt_products').html(),
      productLine : $('#product_line').html(),
      itemPrice: $('#item_price').html(),
      addToCartPrice: $('#fbt_addToCart').html()
    },
    selectors: {
      atcPrice: '.fbtAtcPrice',
      atcAmount: '.fbtAtcAmount',
      atcCurrency: '.fbtAtcPrice__currency',
      atcDollarVal : '.fbtAtcPrice__dollarVal',
      atcCentVal: '.fbtAtcPrice__centVal',
			atcCent: '.fbtAtcPrice__cent',
			fbtContainer: '#fbtContainer',
			lazyLoadImages: '.fbtProductImage'
		},
		init: function initServerSideFbtView() {
			view.updateDOM.lazyLoadImages();
		},
		updateDOM: {
			lazyLoadImages: function lazyLoadImages () {
        $(view.selectors.lazyLoadImages).each( function (index, imageElement) {
          var $imageElement = $(imageElement);
          var updatedUrl = $($imageElement).attr('image-url');
          $imageElement.attr('src', updatedUrl);
          $imageElement.on('load', function(){
            $(this).removeAttr('image-url');
          });
        });
			},
			hideFbtContainer: function hideFbtContainer () {
				$(view.selectors.fbtContainer).hide();
			}
		}
  };
	var presenter = {};

	function initModel(fbtModel) {
		var fbtData = false;

		var fbtState = {
			// TODO: Change this name now that item state is in it.
			itemSelection : {},
			itemIds : []
		};

		function requestFbtData() {
	  		var storeid = pip.customer.localStore && pip.customer.localStore.storenumber ? '&storeid='+ pip.customer.localStore.storenumber : '';
			var url = '/dynamicrecs/fbt?anchor=' + pip.products.primary.data.itemId + storeid;
			if(fbtModel){
				var fbtModelParam = '&model='+fbtModel;
				url = '/dynamicrecs/uts?recstype=ITEM-ITEM&anchor=' + pip.products.primary.data.itemId + storeid + fbtModelParam;
			}
			$.ajax({
				url : url,
				cache : false,
				timeout : 10000,
				dataType: 'json'
			}).done(fbtDataLoaded).fail(fbtDataFailed);
		}

		function fbtDataLoaded(loadedFbtData) {
			fbtData = loadedFbtData;
			if (isFbtDisplayable()) {
				initFbtState();
				fbtInitCallback();
			} else {
        view.updateDOM.hideFbtContainer();
      }
		}

		function fbtDataFailed() {
			console.log('Failed to load fbt data.');
		}

		function isFbtDisplayable() {
			var primaryItem = pip.products.primary.data;
			var isPrimaryDiscontinued = primaryItem.itemAvailability.discontinuedItem;
			var isPrimaryFulfillmentFbtCompatible = pip.fulfillment &&
					(pip.fulfillment.store && pip.fulfillment.store.buyOnlineShipToStore
					|| pip.fulfillment.shipping && pip.fulfillment.shipping.shipToHome
					|| pip.fulfillment.store && pip.fulfillment.store.buyOnlinePickUpInStore && !pip.fulfillment.store.buyOnlinePickUpInStore.isAlphaPromptRestricted
					 && pip.inventory && pip.inventory.store && pip.inventory.store.quantity > 0);

			var fbtItemsAvailable = fbtData && fbtData.products && fbtData.products.length;
			return !isPrimaryDiscontinued && isPrimaryFulfillmentFbtCompatible && fbtItemsAvailable;
		}

		function initFbtState() {
			var primary = getPrimary();
			fbtState.itemIds.push(primary.itemId);
			primary.index = 0;
				fbtState.itemSelection[primary.itemId] = {
				selected : false,
				item : primary
			};
			var fbtItems = fbtData.products;
			$.each( fbtItems, function(counter, fbtItem) {
				fbtState.itemIds.push(fbtItem.productId.toString());
				fbtItem.index = counter + 1;
				fbtState.itemSelection[fbtItem.productId] = {
					selected : false,
					item : fbtItem
				};
			});
		}

		function getPrimary() {
			// TODO: Consider if we should just be using pip.products.primary.data
			// rather than establishing a separate primary object.
			var primary = {};
			primary.isPrimary = true;
			var primaryData = pip.products.primary.data;
			primary.mediaEntryLocation = (function getPrimaryImage145Url() {
				var mediaList = primaryData.media.mediaList;
				for (var i = 0; i < mediaList.length; i++) {
					if (mediaList[i] && mediaList[i].location
							&& mediaList[i].width === "145"
							&& mediaList[i].height === "145"
							&& mediaList[i].mediaType === "IMAGE") {
						return mediaList[i].location;
					}
				}
			})();
			primary.itemId = pip.products.primary.data.itemId;
			primary.availabilityType = primaryData.availabilityType;
			primary.info = primaryData.info;
			primary.isMapPriceScenario = primaryData.itemExtension.isMapPriceScenario;
			primary.storeSkus = primaryData.storeSkus;
			// Normalizing inconsistent names: sku response uses "pricing", fbt response uses "itemPrice".
			var itemPrice = primary.storeSkus[0].itemPrice = primary.storeSkus[0].pricing;
			if (itemPrice && itemPrice.originalPrice) {
				primary.formattedOriginalPrice = formatCurrency(itemPrice.originalPrice);
			}
			if (!primary.isMapPriceScenario) {
				primary.displayPrice = primaryData.itemExtension.displayPrice;
				if (primary.displayPrice) {
					primary.formattedDisplayPrice = formatCurrency(primary.displayPrice);
				}
			}
			return primary;
		}

		// TODO: Consider creating a field for this server-side.
		function isAvailableOnline(availabilityType) {
			var availableOnline = false;
			if (availabilityType) {
				lcAvailabilityType = availabilityType.toLowerCase();
				if ('online' === lcAvailabilityType ||
						'shared' === lcAvailabilityType) {
					availableOnline = true;
				}
			}
			return availableOnline;
		}

		model.setItemSelection = function setItemSelection(itemId, selectionState) {
			var selected;
			if (typeof selectionState !== 'undefined') {
				selected = fbtState.itemSelection[itemId].selected = selectionState;
			} else {
				selected = fbtState.itemSelection[itemId].selected = !fbtState.itemSelection[itemId].selected;
			}
			return selected;
		};

		model.addToCart = function addToCart() {
			var atcItems = model.getSelectedItems();

			var itemDetails = atcItems.map(function(item){
				return {
					itemId: item.itemId || item.productId.toString(),
					quantity: 1
				};
			});

			var multiItemObj = {
				"CartRequest":{
					"itemDetails": itemDetails
				}
			};

			pipCart.addMultiItem(multiItemObj)
				.done(function(data){
					presenter.addToCartSuccessful(data, atcItems);
				})
				.fail(presenter.addToCartFailed);
		};

		model.getPrimaryItemId = function getPrimaryItem() {
			return fbtState.itemIds[0];
		};

		model.getItems = function getItems() {
			var items = [];
			$.each(fbtState.itemIds, function(i, itemId) {
				items.push(fbtState.itemSelection[itemId].item);
			});
			return items;
		};

		model.getItem = function getItem(itemId) {
			return fbtState.itemSelection[itemId].item;
		};

		model.getSelectedItems = function getSelectedItems() {
			var selectedItems = [];
			$.each(fbtState.itemIds, function(i, itemId) {
				var itemState = fbtState.itemSelection[itemId];
				if (itemState.selected) selectedItems.push(itemState.item);
			});
			return selectedItems;
		};

		requestFbtData();
	}

	function initView() {
		var $fbtContainer = $('#fbtContainer');
		var $fbtAtc;
		var $atcButton;
		var $checkboxes;

		function cacheSelectors() {
			$fbtAtc = $fbtContainer.find('.fbtAtc');
			$atcButton = $fbtAtc.find('.bttn-outline');
			$checkboxes = $fbtContainer.find('.checkbox-btn__input');
		}

		function setupEventListeners() {
			$(document).on('click.fbt.link', '.fbtProductImageCont a, .fbtProductLine a', presenter.itemLinkClicked);
			$(document).on('click.fbt', '#fbtContainer .disabled', function(e) { e.preventDefault(); });
		}

		function formatAtcPrice(price) {
			return price.toFixed(2).split('.');
		}

		function isValidNumber(price) {
			return typeof price === "number" && !isNaN(price);
		}

		view.renderMainView = function renderMainView(items) {
			var fbtHtml = Mustache.render(this.templates.main, items, this.templates);
			$fbtContainer.find('.fbt__content').empty().append(fbtHtml);
			cacheSelectors();
			setupEventListeners();
		};

		view.display = function display() {
			$fbtContainer.show();
		};

		// TODO: Name is bad
		view.setAtcEnabled = function setAtcEnabled(isAtcEnabled) {
			$atcButton.toggleClass('disabled', !isAtcEnabled);
			$fbtAtc.find('.fbtAtcPrice').toggleClass('fbtOpacitizer', !isAtcEnabled);
			$atcButton.off('click.fbt.atc');
			if (isAtcEnabled) {
				$atcButton.on('click.fbt.atc', presenter.addToCartClicked);
			}
		};

        view.setAtcMessage = function setAtcMessage(msg) {
            $fbtContainer.find('.fbtPriceMessage').text(msg.priceMessage);
            $fbtContainer.find('.fbtAtcMessage').text(msg.atcMessage);
        };

		view.setAtcPrice = function setAtcPrice(price, atcOriginalPrice) {
		var addToCartPrices = {
		  atcPriceLessthanDollar: false,
		  atcSavingsPrice: 0,
		  isSavingsPrice: false,
		  atcPercentSavings: 0
		};
      if(isValidNumber(price)) {
        if(isValidNumber(atcOriginalPrice)) {
          addToCartPrices.atcSavingsPrice = atcOriginalPrice - price;
          addToCartPrices.atcPercentSavings = parseInt((addToCartPrices.atcSavingsPrice / atcOriginalPrice) * 100);
        }
        addToCartPrices.price = formatAtcPrice(price);
        if (addToCartPrices.price[0] === '0' && addToCartPrices.price[1] !== '00') {
          addToCartPrices.atcPriceLessthanDollar = true;
        }
      }
      if(addToCartPrices.atcSavingsPrice > 0) {
        addToCartPrices.isSavingsPrice = true;
        if (atcOriginalPrice < 1) {
          addToCartPrices.atcOriginalPrice = (atcOriginalPrice * 100).toFixed(0) + '¢';
        } else {
          addToCartPrices.atcOriginalPrice = '$' + atcOriginalPrice.toFixed(2);
		}
        if (addToCartPrices.atcSavingsPrice < 1) {
          addToCartPrices.atcSavingsPrice = (addToCartPrices.atcSavingsPrice * 100).toFixed(0) + '¢';
        } else {
          addToCartPrices.atcSavingsPrice = '$' + addToCartPrices.atcSavingsPrice.toFixed(2);
        }
      }
      var fbtAtcHtml = Mustache.render(this.templates.addToCartPrice, addToCartPrices );
      $fbtContainer.find('.fbtAtcPrice').html(fbtAtcHtml);
		};

		view.setSelectionEnabled = function setSelectionEnabled(isSelectionEnabled) {
			$checkboxes.toggleClass('disable', !isSelectionEnabled);
			$checkboxes.off('click.fbt.cb');
			if (isSelectionEnabled) {
				$checkboxes.on('click.fbt.cb', presenter.itemSelected);
			}
		};

		view.setItemSelected = function setItemSelected(itemId, isItemSelected) {
			// Could iterate $checkboxes.
			var $checkbox = $fbtContainer.find('[data-itemid=' + itemId + ']').closest('.checkbox-btn');
			$checkbox.find('.checkbox-btn__input').prop('checked', isItemSelected);
			$checkbox.find('.fbtProductMsg').toggleClass('fbtOpacitizer', !isItemSelected);
			var $fbtProductImage = $fbtContainer.find('.fbtProductImageCont[data-itemid=' + itemId + ']');
			$fbtProductImage.find('.fbtProductImage').toggleClass('fbtOpacitizer', !isItemSelected);
		};

		view.buildOverlay = function(data, atcItems){
			var isError = data.CartModel.errorModel;

			if(!isError){
				fbtAtcOverlay.display({ items: atcItems.length });
        pipEvents.cart.addtoCartOverlay.trigger(
					fbtAtcOverlay.getAnalyticsAtcOverlayEventData(data.CartModel.itemModels, atcItems.map(function (item) { return item.itemId || item.productId.toString();}))
        );
			} else {
				fbtAtcOverlay.displayError();
			}
		}
	}

	function initPresenter() {
		var atcProcessing;

		function setupInitialModelAndView() {
			var items = model.getItems();
      $.each(items, function (i, item) {
        if (item.displayPrice < 1) {
          item.displayPriceLessThanDollar = true;
        }
        if (item.formattedOriginalPrice && item.formattedOriginalPrice.indexOf('$') === -1) {
          item.originalPriceLessThanDollar = true;
        }
        if (item.imageURL && item.imageURL.indexOf('<SIZE>') !== -1) {
          // FBT image has constant 145  size on all products
          item.imageURL = item.imageURL.replace('<SIZE>', '145');
        }
      });
			view.renderMainView({'items' : items });
			batchSetModelAndView(true, items);
			view.display();
		}


		function batchSetModelAndView(selectionState, items) {
			if (typeof items === 'undefined') {
				items = model.getItems();
			}
			$.each(items, function(i, item) {
				model.setItemSelection(item.productId || item.itemId, selectionState);
				view.setItemSelected(item.productId || item.itemId, selectionState);
			});
			view.setSelectionEnabled(true);
			view.setAtcMessage(getAddToCartMessage());
			view.setAtcPrice(getAddToCartPrice(), getAddToCartOriginalPrice());
			view.setAtcEnabled(selectionState);
		}

		function isCartEnabled() {
			return model.getSelectedItems().length ? true : false;
		}

		function getAddToCartMessage() {
			var message = {};
			var numberSelected = model.getSelectedItems().length;
			if (numberSelected <= 1) {
				message.priceMessage = 'Price:';
				message.atcMessage = 'Add to cart';
			} else if (numberSelected == 2) {
				message.priceMessage = 'Price for both:';
				message.atcMessage = 'Add both to cart';
			} else if (numberSelected == 3) {
				message.priceMessage = 'Price for all three:';
				message.atcMessage = 'Add all three to cart';
			}
			return message;
		}

		function getAddToCartPrice() {
			var addToCartPrice = 0;
			var selectedItems = model.getSelectedItems();
			$.each(selectedItems, function(i, item) {
			  var itemPrice = item.price || item.displayPrice;
				if (item.isMapPriceScenario || item.mapAboveOriginalPrice != null || !itemPrice) {
					addToCartPrice = '';
					return false;
				} else {
					addToCartPrice += item.displayPrice || item.price;
				}
			});
			return addToCartPrice;
		}

		function getAddToCartOriginalPrice() {
			var addToCartOriginalPrice = 0;
			var selectedItems = model.getSelectedItems();
			$.each(selectedItems, function(i, item) {
        var itemPrice = item.price || item.displayPrice;
				if (item.isMapPriceScenario || item.mapAboveOriginalPrice != null || !itemPrice) {
					addToCartOriginalPrice = '';
					return false;
				} else {
					if (!item.formattedOriginalPrice || !itemPrice) {
						addToCartOriginalPrice += item.displayPrice || item.price;
					} else if (!item.formattedOriginalPrice.match(/[$|/.]/)) {
						addToCartOriginalPrice += parseInt(item.formattedOriginalPrice.replace( /[^0-9]/, '' )) / 100;
					} else {
						addToCartOriginalPrice += Number(item.formattedOriginalPrice.replace( /[^0-9|/.]/, '' ));
					}
				}
			});
			return addToCartOriginalPrice;
		}

		function addToCartProcessed() {
			atcProcessing = false;
			batchSetModelAndView(false);
		}

    function getAnalyticsAtcEventData(atcItems) {

			var stash = {
				item: [],
				component: 'product pod',
				pageType: 'pip',
				section: 'dyn prod rec',
				sharedSection: 'n/a',
				target: 'atc'
			};
			var primaryItemId = model.getPrimaryItemId();

			if (Array.isArray(atcItems) && atcItems.length === 1 && (atcItems[0].itemId === primaryItemId)) {
				var analyticsAtcItem = {
					productInfo: {
						sku: atcItems[atcItems.length-1].itemId
					},
					displayPosition: String(atcItems.length)
				};
				stash.item.push(analyticsAtcItem);
			} else if (Array.isArray(atcItems) && atcItems.length) {
				atcItems.forEach(function (atcItem, index) {
					if (!atcItem.isPrimary) {
						var analyticsAtcItem = {
							productInfo: {
								sku: atcItem.productId
							},
							displayPosition: String(index + 1)
						};

						analyticsAtcItem.recommendation = {
							recommendationType: 'fbt',
							pageType: 'pip',
							anchorProductSku: primaryItemId,
							strategy: 'n/a',
							recommendationVersion: 'n/a',
							featureVersion: 'n/a',
							interval: 'n/a'
						};
						stash.item.push(analyticsAtcItem);
					}
				});
			}
			return stash;
		}

		presenter.itemLinkClicked = function itemLinkClicked(e) {
			var $currentTarget = $(e.currentTarget);
      		var index = $currentTarget.data('index');
			e.preventDefault();
			pipEvents.fbt.fbtLinkClicked.trigger({
				displayPosition: index,
				anchorProductSku: pip.products.primary.data.itemId,
				href: $(this).attr('href')
			});
		};

		presenter.itemSelected = function itemSelected(e) {
			if (atcProcessing) return;

			var $currentTarget = $(e.currentTarget);
			var itemId = $currentTarget.data('itemid');
			var isItemSelected = model.setItemSelection(itemId);
			view.setItemSelected(itemId, isItemSelected);
			view.setAtcMessage(getAddToCartMessage());
			view.setAtcPrice(getAddToCartPrice(), getAddToCartOriginalPrice());
			view.setAtcEnabled(isItemSelected || isCartEnabled());
		};

		// TODO: Consider moving the ATC call to here.
		presenter.addToCartClicked = function addToCartClicked(e) {
			if (atcProcessing) return;

			atcProcessing = true;
			view.setSelectionEnabled(false);
			view.setAtcEnabled(false);
			model.addToCart();
		};

		presenter.addToCartSuccessful = function addToCartSuccessful(data, atcItems) {
			addToCartProcessed();
			pipEvents.cart.multiItemAddToCart.trigger(getAnalyticsAtcEventData(atcItems));
			view.buildOverlay(data, atcItems);
			pipEvents.cart.addToCart.trigger();
		};

		presenter.addToCartFailed = function addToCartFailed() {
			addToCartProcessed();
			console.log('FBT add-to-cart failed.');
		};

		setupInitialModelAndView();
	}

	// TODO: How many of these exist across HD codebases.  Use common one if avail.
	// If not a common one, then need to address current problem where both model
	// and view are having to use this function.
	function formatCurrency(price) {
		if (typeof price === 'number') {
      if (price < 1) {
          return (Number(price) * 100).toFixed(0); }
      else {
          return '$' + Number(price).toFixed(2);
      }
		}
	}

// Call the FBT if the RecommendationFeature flag for "FBT" is true and bareCushionFeature not enabled for an item
   function isFbtRequestable() {
	  return (pip.products.primary.data.info.recommendationFeatures&&
        pip.products.primary.data.info.recommendationFeatures.indexOf('FBT') > -1
			  && pip.products.primary.data.itemExtension.merchandise
			  && !pip.products.primary.data.itemExtension.bareCushion);
}

    function fbtInitCallback() {
	    initView();
	    initPresenter();
	    pip.setFlag('fbtDisplayed', true);
	    pipEvents.fbt.fbtInitComplete.trigger();
}

	return {
		init: function init() {
		if (isFbtRequestable()) {
			view.init();
			if (pip.features.fbtDataDynamicallyFromTnTEnabled) {
				var fbtModel = window.testAndTarget && window.testAndTarget.fbtModel;
				if (fbtModel) {
					initModel(fbtModel);
				} else {
					setTimeout(function () {
						fbtModel = window.testAndTarget && window.testAndTarget.fbtModel;
						initModel(fbtModel);
					}, 500);
				}
			} else {
				initModel();
			}
		} else {
			view.updateDOM.hideFbtContainer();
		}
	  },
	isFbtRequestable : isFbtRequestable
};

});

}.call(window));